export default "__VITE_ASSET__f58cca16__"